import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/ai.js';
import q from '../query.js';
export const aiAutoReplyEntity = 'ai-auto-replies';
export const aiUsageEntity = 'ai-usage';
export const proposedCategoriesEntity = 'proposed-interaction-categories';
export const aiAutoReplyKey = (id) => `ai-auto-reply-${id}`;
export const useAIAutoReply = (id) => q.query(aiAutoReplyKey(id), () => api.getAutoReply(id), [aiAutoReplyEntity, id], { enabled: id != null });
export const useAIUsage = () => q.query('ai-usage', () => api.getUsage(), keys.read.collection(aiUsageEntity));
export const useProposedCategories = () => q.query(proposedCategoriesEntity, api.getProposedCategories, keys.read.collection(proposedCategoriesEntity));
//# sourceMappingURL=index.js.map